import React from 'react';
import TimeSlot from './TimeSlot/TimeSlot';
import { Col, Row, Form, Table } from 'react-bootstrap';
import LoadingScreen from '../../hoc/LoadingScreen';
import {formatTimestamps} from '../../util/parseDate';

const timeSlots = (props) => {

  let content = null;

  if(props.selectedSlot===null){
    const slots = props.slots.map((el, index) => {
      return (
        <TimeSlot 
          key={index} 
          start={el.start} 
          end={el.end}
          clicked={() => { props.selected(el) }} />
      );
    });

    if(props.slots.length===0){
      content = (
          <tbody>
            <tr><td colSpan="2" className="text-center"><b>Sellel päeval ei leidu ühtegi vaba aega. Valige mõni teine kuupäev.</b></td></tr>
          </tbody>
      );
    }else{
      content = (
          <tbody>
            {slots}
          </tbody>
      );
    }


  }else{

    const [selectedStart, selectedEnd] = formatTimestamps(props.selectedSlot.start, props.selectedSlot.end);

    content = (
      <tbody>
        <tr className="cursor-pointer" onClick={() => props.emptied()}>
          <td className="text-center">{selectedStart}</td>
          <td className="text-center">{selectedEnd} <i className="fa fa-trash-o edit-time-icon"></i></td>
        </tr> 
      </tbody>
    );
  }

  

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <Form.Group>
            <Form.Label><i className="fa fa-clock-o"></i> Vali sobiv kellaaeg</Form.Label>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th className="text-center">Algus</th>
                  <th className="text-center">Lõpp</th>
                </tr>
              </thead>
              {content}
            </Table>
          </Form.Group>
        </Col>
      </Row>
    </LoadingScreen>
  )

}

export default timeSlots;